import "@/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Sentry } from "@/sentry";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-50">
          <div className="max-w-md border border-red-300 bg-white p-8 text-center">
            <h1 className="font-display font-extrabold text-2xl tracking-tight text-zinc-900">
              Something went wrong.
            </h1>
            <p className="mt-3 text-sm text-zinc-600">
              Our team has been notified. Try refreshing the page.
            </p>
            <button
              type="button"
              onClick={resetError}
              className="mt-6 px-5 py-2 bg-blue-700 text-white font-bold uppercase tracking-wide text-xs"
            >
              Reload
            </button>
          </div>
        </div>
      )}
      beforeCapture={(scope) => scope.setTag("section", "app-root")}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
